<div class="gravty-global-loader">
  <img
    src="../../../../../assets/images/icons/loading.gif"
    alt="Loader"
    class="gravty-global-loader__animation"
  />
  <span class="gravty-global-loader__text">Loading Please Wait...</span>
</div>
